<template>
  <div class="warehouse">
    <Production
      v-if="configAccess.warehouse.production > 0 && production"
      :supplier="supplierCheck()"
    />

    <div v-if="isWarehouseTable" class="warehouse__wrapper">
      <div
        :class="[
          { 'warehouse__title--head': !configAccess.warehouse.production },
          'warehouse__title',
        ]"
      >
        Информация о наличии
      </div>

      <Load v-if="getDealer.has_warehouse" :isShowDealerPrice="isShowDealerPrice" />

      <div class="warehouse__panel">
        <SwitchBlock
          v-if="isSwitchBlock"
          @switchClick="updateUserInfoWarehouseSet"
          :active="getDealer.has_warehouse ? true : false"
          :text="'Есть свой оптовый склад:'"
          :disabled="getParentDealer ? false : true"
          :access="configAccess.warehouse.availability === 2 ? true : false"
          class="warehouse__switch"
        />

        <a
          href="https://amigo.ru/dealer/informatsiya-o-nalichii/nal_rul/"
          target="_blank"
          class="warehouse__link"
        >
          Информация о наличии на сайте Амиго
        </a>

        <Tabs
          v-if="tabs.length"
          :class="['tab--warehouse', { 'tab--single': tabs.length < 2 }]"
          :tabs="tabs"
          :active="tabActive"
          @tabActiveUpdate="tabActiveUpdate"
          :isTabScroll="isWidthForScroll"
        >
        <div ref="tabs" :class="[{ 'width-scroll': isWidthForScroll }]">
          <Materials
            v-show="tabActive === 'material'"
            :list="warehouse.materials"
          />
          <Opt v-show="tabActive === 'opt'" :list="warehouse.opt" />
        </div>
        </Tabs>
      </div>
    </div>
  </div>
</template>

<script>
import {
  mapActions,
  mapGetters,
  mapMutations,
  mapState,
} from 'vuex';

import mixinWholesale from '@/mixins/Account/warehouse/wholesale.mixin';

export default {
  name: 'AccountWarehouse',

  mixins: [mixinWholesale],

  components: {
    Tabs: () => import('@/pages/account/components/Tabs'),
    SwitchBlock: () => import('@/pages/account/components/Switch'),
    Production: () => import('./components/production/Production'),
    Materials: () => import('./components/Materials'),
    Opt: () => import('./components/Opt'),
    Load: () => import('./components/Load'),
  },

  data: () => ({
    tabs: [
      {
        name: 'Материалы',
        path: 'material',
      },
      {
        name: 'Комплектующие',
        path: 'opt',
      },
    ],
    tabActive: 'material',
    isShowDealerPrice: false,
    isWidthForScroll: true,
  }),

  metaInfo() {
    return {
      title: `Сроки изготовления - Личный кабинет дилера - ${this.getDealerName}`,
    };
  },

  computed: {
    ...mapState({
      configAccess: state => state.user.configAccess,
      production: state => state.account.warehouse.production,
      warehouse: state => state.account.warehouse.warehouse,
    }),

    ...mapGetters('user', ['getDealer', 'getDealerName', 'getDealerPricelist', 'getParentDealer']),

    isWarehouseTable() {
      const result = this.configAccess.warehouse.availability > 0 && this.warehouse;
      return result;
    },

    isSwitchBlock() {
      const level = this.getDealer?.level;

      if (level > 2) {
        return false
      }

      return true;
    }
  },

  watch: {
    isWarehouseTable() {
      this.$nextTick(() => {
        setTimeout(() => {
          this.updateIsWidthForScroll();
        }, 1000)
      })
    }
  },

  methods: {
    ...mapActions('account/warehouse', ['productionLoad', 'warehouseLoad']),

    updateUserInfoWarehouseSet() {
      if (this.getDealerPricelist && this.getDealer.has_warehouse) {
        this.updatePopup(true, 'PopupWarehouseWholesale');
      } else {
        this.$_wholesale_update();
      }
    },
    // костыль, для расчет необходимости скролла
    updateIsWidthForScroll() {
      if (this.isMobileOuter) {
        this.isWidthForScroll = false;
      } else {
        this.isWidthForScroll = true;

        this.$nextTick(() => {
          const offsetWidth = this.$refs?.tabs?.offsetWidth;

          if (offsetWidth) {
            this.isWidthForScroll = offsetWidth > window.outerWidth;
          }
        })
      }
    },

    tabActiveUpdate(name) {
      this.tabActive = name;
    },

    supplierCheck() {
      const check = () => {
        for (let i = 0; i < this.production.length; i++) {
          const item = this.production[i].models;
          if (item.length > 0) {
            return item;
          }
        }
      };
      return check()[0].production?.supplier !== undefined ? true : false;
    },

    deleteTab(path) {
      const index = this.tabs.findIndex(el => el.path === path);

      if (index !== -1) {
        this.tabs.splice(index, 1);
      }

      if (this.tabs.length) {
        this.tabActive = this.tabs[0].path;
      }
    },

    async fetchData() {
      if (this.configAccess.warehouse.production > 0) {
        await this.productionLoad();
      }
      if (this.configAccess.warehouse.availability > 0) {
        await this.warehouseLoad().then(res => {
          if (!res.opt.length) {
            this.deleteTab('opt');
          }

          if (!res.materials.length) {
            this.deleteTab('material');
          }

          this.isShowDealerPrice = res?.show_dealer_price || false;
        });
      }
    },

    handlerResize() {
      this.updateIsWidthForScroll();
    }
  },

  created() {
    this.togglePreload();
    this.fetchData().finally(() => {
      this.togglePreload();
    });

    window.addEventListener("resize", this.handlerResize);
  },

  destroyed() {
    window.removeEventListener("resize", this.handlerResize);
  },
};
</script>

<style scoped lang="scss">
.width-scroll {
  width: fit-content;
}

.warehouse {
  padding: 0 15px;

  @media (max-width: $desktop) {
    padding: 0 0 40px;
  }

  &__panel {
    position: relative;
  }

  &__title {
    font-weight: bold;
    font-size: 24px;
    line-height: 30px;
    margin: 0 0 24px;
    text-align: center;

    @media (max-width: $desktop) {
      margin-bottom: 12px;
    }

    &--head {
      position: fixed;
      z-index: 120;
      left: 50%;
      transform: translateX(-50%);
      top: 0;
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: center;
      height: 53px;
      margin: 0;

      @media (max-width: $desktop) {
        position: static;
        height: auto;
        transform: translateX(0);
      }
    }
  }

  &__list {
    margin: 0 -15px 7px;
    position: relative;

    @media (max-width: $desktop) {
      margin: 0 -20px 7px;
    }
  }

  &__switch {
    position: absolute;
    left: 0;
    top: 7px;

    @media (max-width: $desktop) {
      position: static;
      margin-bottom: 30px;
    }
  }

  &__link {
    position: absolute;
    right: 0;
    top: 7px;
    display: inline-block;
    font-size: 14px;
    line-height: 20px;
    color: #4b9dbd;

    @media (max-width: $desktop) {
      position: static;
      display: block;
      margin: 0 auto 30px;
      width: fit-content;
      margin-bottom: 30px;
    }
  }

  &__check {
    background-color: transparent;
    width: 34px;
    height: 20px;
    border-radius: 24px;
    border: 1px solid #000;
    padding: 0;
    margin: 0 0 0 15px;
    position: relative;
    transition: 0.3s;

    &:after {
      content: '';
      display: block;
      width: 14px;
      height: 14px;
      border-radius: 100%;
      background-color: #000;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: 3px;
      transform: translateX(0);
      transition: 0.3s;
    }

    &.active {
      background-color: #000;

      &:after {
        background-color: #fff;
        transform: translateX(12px);
      }
    }
  }
}
</style>
